module.exports = __webpack_public_path__ + "static/media/guest.fbed7f56.svg";